export enum AnalysisFormStep {
  LOCATION,
  DATE_TIME,
  PARAMETER,
  CONTEXTS,
}
